import { Grid, Typography } from '@material-ui/core';
import React, { VFC } from 'react';
import { FormattedMessage } from 'react-intl';

import { BackToCompanySettings } from 'components/BackToCompanySettings';

import { messages } from './messages';
import { useStyles } from './styles';

export const Header: VFC = () => {
  const styles = useStyles();

  return (
    <Grid
      item
      container
      direction="row"
      justify="space-between"
      alignItems="center"
      className={styles.title}
    >
      <Grid item>
        <BackToCompanySettings />
        <Typography display="inline" variant="h2">
          <FormattedMessage {...messages.automatedResponses} />
        </Typography>
      </Grid>
    </Grid>
  );
};
